// extracted by mini-css-extract-plugin
export var appear = "Sidebar-module--appear--f9ZDS";
export var inner = "Sidebar-module--inner--GNF43";
export var root = "Sidebar-module--root--vG6BS";
export var wrapper = "Sidebar-module--wrapper--EQ8Kl";